var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThemes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1429 13.6246L15.4975 1L1.90369 14.5714C1.32445 15.1614 1 15.9546 1 16.7807C1 17.6069 1.32445 18.4001 1.90369 18.99L10.1232 27.196C11.3877 28.4585 13.2845 28.4585 14.5491 27.196L28.1429 13.6246Z",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8095 16.7794L15.4048 16.7794L4.57143 16.7129H1C1 17.539 1.32445 18.3987 1.90369 18.9887L10.1232 27.1947C11.3877 28.4571 13.2845 28.4571 14.5491 27.1947L24.8095 16.7794Z",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9997 28.0625C30.9997 28.8413 30.6862 29.5882 30.128 30.1389C29.5699 30.6896 28.8129 30.999 28.0236 30.999C27.2342 30.999 26.4772 30.6896 25.9191 30.1389C25.3609 29.5882 25.0474 28.8413 25.0474 28.0625C25.0474 25.7133 27.5771 24.5387 28.0236 22.1895C28.47 24.5387 30.9997 25.7133 30.9997 28.0625Z",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemes);
export default __webpack_public_path__ + "static/media/Themes.70d1bf1a2ad19c2595d579f19e2484fa.svg";
export { ForwardRef as ReactComponent };